<div class="flex flex-col gap-4" *transloco="let t">
  <ISelectMenu class="w-full" [(value)]="brandSelected" by="brandId" fitTriggerWidth [(searchQuery)]="searchQuery">
    <ISelectTrigger class="flex w-full">
      <ISelectValue [placeholder]="t('brand-merge-modal.select_brand')">
        <div *iSelectValue="let value">{{ value?.brandAlias }}</div>
      </ISelectValue>
    </ISelectTrigger>
    <ISelectContent>
      @for (brand of filteredBrands(); track brand.brandId) {
        <ISelectOption [value]="brand">
          {{ brand.brandAlias }}
        </ISelectOption>
      }
    </ISelectContent>
  </ISelectMenu>
  <div class="flex justify-end gap-2">
    <button iButton variant="ghost" size="md" (click)="close()">{{ t("common.cancel") }}</button>
    <button iButton size="md" [disabled]="!brandSelected()" (click)="merge()">
      {{ t("common.merge") }}
    </button>
  </div>
</div>
